export default __webpack_public_path__ + "static/media/schedule.03b77ffb.png";